import axios from 'axios';
import BaseComponent from 'scripts/BaseComponent.js';
import UnderlayHelper from '../../global/underlay-helper';
import { AccessibilityHelper } from '../../../scripts/accessibility/accessibilityHelper';

export default class SizeGuidePdpModal extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      closeBtn: '.js-closeSizeGuideBtn',
      container: '.js-modalTableContainer',
      table: '.js-sizeGuideModalTable',
    };

    this.dom = {
      $component: component,
      $closeBtn: this.$get(this.refs.closeBtn),
      $container: this.$get(this.refs.container),
    };

    this.state = {
      openClass: 'is-open',
      showClass: 'show',
      animationDuration: 500,
      underlayHelper: new UnderlayHelper({ overNav: true }),
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
      openSizeGuideModalEvent: 'opensizeguidemodal',
      mountModalSizeGuideTable: 'mountmodalsizeguidetable',
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.state.tableFetched = false;
    this.setOnCustomEvent(state.openSizeGuideModalEvent, this.openModal);
    this.setClick(dom.$closeBtn, this.closeModal);
    state.underlayHelper.addClickListener(this.closeModal.bind(this));
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
  }

  async fetchTable() {
    const { dom: { $container } } = this;
    const { tablePage, shape } = $container.dataset;
    const url = `/pages/${tablePage}`;

    try {
      const { data } = await axios.get(url);
      const parser = new DOMParser();
      const page = parser.parseFromString(data, 'text/html');

      this.parseTable(page, shape);
    } catch (e) {
      console.log('Error fetching size guide table', e);
    }
  }

  parseTable(page, shape) {
    const { dom, state, refs } = this;
    const table = page.querySelector(`${refs.table}[data-shape="${shape}"]`);

    if (!table) return;

    dom.$container.innerHTML = table.innerHTML;
    this.dispatch(state.mountModalSizeGuideTable);
  }

  openModal() {
    const { dom, state } = this;

    if (!state.tableFetched) {
      this.fetchTable();
      state.tableFetched = true;
    }

    dom.$component.classList.add(state.openClass);
    setTimeout(() => {
      dom.$component.classList.add(state.showClass);
    }, 0);

    state.underlayHelper.open();
    state.focusTrap.set();
  }

  closeModal() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.showClass);
    setTimeout(() => {
      dom.$component.classList.remove(state.openClass);
    }, state.animationDuration);

    state.underlayHelper.close();
    state.focusTrap.unset();
  }
}
